<template>
  <div class="weui-btn-area">
    <slot />
  </div>
</template>

<script>
export default {
    name: 'ButtonArea',
};
</script>



// WEBPACK FOOTER //
// src/components/weui/button-area/Index.vue